module.exports = __webpack_public_path__ + "static/media/cUSD.0af2fbb9.png";